import type { Routes } from '@angular/router';

export const AGGREGATED_SOCIAL_NETWORKS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-social-networks-layout/aggregated-social-networks-layout.component').then(
                (m) => m.AggregatedSocialNetworksLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'posts',
            },
            {
                path: 'posts',
                loadChildren: () =>
                    import('#modules/posts/routes/pending-validation-social-posts.routing').then(
                        (m) => m.PENDING_VALIDATION_SOCIAL_POSTS_ROUTES
                    ),
            },
            {
                path: 'stories',
                loadChildren: () =>
                    import('#modules/posts/routes/pending-validation-stories.routing').then((m) => m.PENDING_VALIDATION_STORIES_ROUTES),
            },
        ],
    },
];
